import { FormHelp } from '@zillow/constellation-10';

/**
 * Reserves the description line so a field does not shift when its error message appears or clears.
 * Pass it as the falsy arm of a `FormField`/`FieldSet` `description` ternary.
 */
const DescriptionPlaceholder = () => <FormHelp aria-hidden="true">{' '}</FormHelp>;

export default DescriptionPlaceholder;
